module.exports = __webpack_public_path__ + "static/media/NumberlistBlue.b90dc49b.svg";